import { NextPage, NextPageContext } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import GetSupport from "@containers/GetSupportLP";
import { canonicalLink } from "@helpers/url";
import { getProductMenu } from "@libraries/api/product-menu/product-menu.repos";
import { TProductIconData } from "@layouts/Main/lib/Header/lib/MenuProduct/type";
import { fetchGenerateToken } from "@libraries/api/generate-token/generate-token.repos";
import { getFaqList } from "@libraries/api/faq-list/faq-list.repos";
import type { IFaqData } from "@containers/FAQ/interface";
import { localeKey } from "@constants/locale-key";

export interface IPropsPageBantuan {
  dataNavbar: TProductIconData[];
  dataFaq: IFaqData[];
}

const PageBantuan: NextPage<IPropsPageBantuan> = ({ dataNavbar, dataFaq }) => {
  return (
    <GetSupport dataFaq={dataFaq} topic="" dataNavbar={dataNavbar} />
  );
};

export async function getServerSideProps(context: NextPageContext) {
  const clientId = `${process.env.CLIENT_ID}`;
  const clientSecret = `${process.env.CLIENT_SECRET}`;
  const lang = `${context.locale}`;
  const EN = lang === "en";
  const searchQuery = `${context.query?.search}`;
  const { data: dataProductMenu } = await getProductMenu({ level: 0 }, lang);
  const { data: dataToken } = await fetchGenerateToken({ clientId, clientSecret });

  /** Set parameter to pass over API List FAQ based on search or limit */
  let params;

  if (searchQuery && searchQuery !== "undefined" && searchQuery !== "") {
    params = {
      search: searchQuery,
    };
  } else {
    params = { limit: 5 };
  }

  const token = dataToken.accessToken;
  const { data: dataFaqResp } = await getFaqList(params, token, lang);

  return {
    props: {
      ...(await serverSideTranslations(context.locale ?? "id", localeKey)),
      title: EN ? "Help and Contact Us" : "Bantuan dan Hubungi Kami",
      description: EN
        ? "Contact us if you need assistance or further information regarding MyTEnS"
        : "Hubungi kami jika membutuhkan bantuan atau informasi lebih lanjut terkait MyTEnS",
      imageUrl: "https://storage-assurance-dev.mytens.id/assets/mytenscustomer/call-support.png",
      canonical: canonicalLink("/bantuan", lang),
      dataNavbar: dataProductMenu,
      dataFaq: dataFaqResp,
    },
  };
}

export default PageBantuan;
